export default () => ({
  formattedCurrentMessages: {
    public: [],
    private: []
  },
  filtered: [],
  highlight: undefined,
  draft: [],
  macros: [],
  usedMacros: [],
  isPrivate: false,
  isSendingFile: false,
  messagesListener: null,
  replyTo: null,
  currentPage: 0,
  endPagination: false
})
